import { DetailsExpertiseAttachmentActionTypes } from './types';
import { ExpertiseAttachmentResponse } from './model';
import { action } from 'typesafe-actions';

export const fetchExpertiseAttachments = (instructionId: number) =>
  action(DetailsExpertiseAttachmentActionTypes.FETCH_EXPERTISE_ATTACHMENTS, { instructionId });

export const fetchExpertiseAttachmentsSuccess = (expertiseAttachments: ExpertiseAttachmentResponse[]) =>
  action(DetailsExpertiseAttachmentActionTypes.FETCH_EXPERTISE_ATTACHMENTS_SUCCESS, expertiseAttachments);

export const fetchExpertiseAttachmentsError = (message: string) =>
  action(DetailsExpertiseAttachmentActionTypes.FETCH_EXPERTISE_ATTACHMENTS_FAIL, { message });

export const resetDetailsExpertiseAttachmentState = () =>
  action(DetailsExpertiseAttachmentActionTypes.RESET_STATE);

export const previewAttachment = (amazonId: string) => action(DetailsExpertiseAttachmentActionTypes.SET_PREVIEW_AMAZON_ID, { amazonId });
